import { render, staticRenderFns } from "./pretty-print.vue?vue&type=template&id=b4510e60&"
import script from "./pretty-print.vue?vue&type=script&lang=js&"
export * from "./pretty-print.vue?vue&type=script&lang=js&"
import style0 from "./pretty-print.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports